let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToTarget = (target, immediate = false) => {
  if (target === "#top" || target === 0) {
    if (lenis) lenis.scrollTo(0, { immediate });
    else window.scrollTo({ top: 0, behavior: immediate ? "auto" : "smooth" });
    return;
  }
  const el = document.querySelector(target);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -80, immediate });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: immediate ? "auto" : "smooth" });
};

export const lockScroll = (locked) => {
  if (lenis) (locked ? lenis.stop() : lenis.start());
  document.documentElement.style.overflow = locked ? "hidden" : "";
};
